import * as React from 'react';
export const IcMultiSensor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59zM15 10H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3v-6a3 3 0 00-3-3zm-5 9a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4.67-10.44a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44z'
      fill='currentColor'
    />
  </svg>
);
